import React from 'react';
import { Dialog, DialogContent, DialogContentText, DialogActions, Button, Slide, Box } from '@material-ui/core';
import { DrawerTransitionSetting } from '../../../config/utils';
import './BashScriptAlert.scss';

const Transition = React.forwardRef(function Transition(props, ref) {
	return React.createElement(Slide, Object.assign({ direction: 'down', ref: ref }, props));
});

export default function BashScriptAlert(props) {
	const { open, onClose, message, title } = props;

	return (
		<Dialog
			className='default-dialog bash-script-alert-dialog'
			open={open}
			keepMounted
			transitionDuration={DrawerTransitionSetting}
			TransitionComponent={Transition}
			onClose={onClose}
			aria-labelledby='bash-alert-dialog-title'
			aria-describedby='bash-alert-dialog-description'
		>
			<DialogContent>
				<Box className='alert-icon-wrapper'>
					<svg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<circle cx='40' cy='40' r='38' stroke='#FF6B6B' strokeWidth='4' fill='#FFE5E5' />
						<path
							d='M40 20V45M40 55V58'
							stroke='#FF6B6B'
							strokeWidth='6'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
					</svg>
				</Box>
				{title && (
					<DialogContentText className='bash-alert-title' id='bash-alert-dialog-title'>
						{title}
					</DialogContentText>
				)}
				<DialogContentText
					className='bash-alert-message'
					id='bash-alert-dialog-description'
					dangerouslySetInnerHTML={{ __html: message }}
				></DialogContentText>
			</DialogContent>

			<DialogActions>
				<Button className='btn-primary' onClick={onClose} color='primary' autoFocus>
					OK
				</Button>
			</DialogActions>
		</Dialog>
	);
}
